import "date-fns";
import React from "react";
import { useFormContext} from "react-hook-form";
import DateFnsUtils from "@date-io/date-fns";
import { useMaterialDate } from "./useMaterialDate";
import { dateMuiformat } from "../../../utils/date";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker
} from "@material-ui/pickers";
export function MaterialUIDatePickers(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
       <DatePicker
          {...props}
          margin="normal"
          inputVariant="outlined"
         
        />
    </MuiPickersUtilsProvider>
  );
}
